import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'lib-time-carusel',
  templateUrl: './time-carusel.component.html',
  styleUrls: ['./time-carusel.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeCaruselComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TimeCaruselComponent implements OnInit, ControlValueAccessor {
  @Input() step = 15; // minute step
  @Input() initValue: string;

  private _value: Date;
  @Input() set value(val: Date) {
    this._value = val;
  }
  @ViewChild('timeInput') timeInput!: ElementRef<HTMLInputElement>;

  onChange: any = () => {};
  onTouched: any = () => {};
  formattedTime: string;

  constructor(private cdr: ChangeDetectorRef) {}
  ngOnInit(): void {
    if (this.initValue) {
      const newDate = new Date(this.initValue);
      this.writeValue(newDate);
    }
  }

  getFormattedTime() {
    const h = this._value.getHours().toString().padStart(2, '0');
    const m = this._value.getMinutes().toString().padStart(2, '0');
    this.formattedTime = `${h}:${m}`;

    return this.formattedTime;
  }

  adjust(minutes: number): void {
    const newDate = new Date(this._value);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    this.writeValue(newDate);
    this.onChange(this._value);
    this.getFormattedTime();
  }

  validateAndSet(): void {
    const input = this.timeInput.nativeElement.value;
    const parts = input.split(':');
    let h = Number(parts[0]);
    let m = Number(parts[1]);

    if (isNaN(h)) {
      h = this._value.getHours();
    }
    if (isNaN(m)) {
      m = this._value.getMinutes();
    }

    h = Math.max(0, Math.min(23, Math.floor(h)));
    m = Math.max(0, Math.min(59, Math.floor(m)));

    const newDate = new Date(this._value);
    newDate.setHours(h);
    newDate.setMinutes(m);
    newDate.setSeconds(0);

    this.writeValue(newDate);
    this.onChange(this._value);
    this.timeInput.nativeElement.value = this.getFormattedTime();
  }

  writeValue(value: Date): void {
    if (value instanceof Date && !isNaN(value.getTime())) {
      this._value = value;
    }
    this.getFormattedTime();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
